import packageJson from "../../../../../package.json";

const {version} = packageJson;

export const getAppVersion = (appName: "SF") => {
    // change package.json's A.BB.CCC => BB.CCC
    const shortVersion = version
        .split(".")
        .filter((_, i, all) => i === 1 || i === all.length - 1)
        .join(".");
    return `${appName}.${shortVersion}`;
};
